import {
  makeStyles, useMediaQuery
} from '@material-ui/core'
import {
  SWAPSpace,
  Tooltip,
  Typography
} from '@yosgo/swap-ui'
import Avatar from './Avatar'
import { Member } from './ListBlock'
import { Chip } from '../Profile'

const useStyles = makeStyles({
  card: {
    width: '100%',
    backgroundColor: '#ffffff',
    border: '1px solid #CCCCCC',
    borderRadius: 8,
    boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      boxShadow: '0px 8px 40px rgba(0, 0, 0, 0.16)',
    },
    cursor: 'pointer'
  }
})

interface ResumeCardComponentProps {
  data?: Member,
  onClick?: () => void,
}
const ResumeCardComponent = ({
    data,
  }: ResumeCardComponentProps) => {
  const classes = useStyles()
  // const match1200 = useMediaQuery('(min-width:1200px)')
  // const match992 = useMediaQuery('(min-width:992px)')
  const match768 = useMediaQuery('(min-width:768px)')

  if (!data) return null

  const bio = data && data.bio ? JSON.parse(data.bio) : undefined
  const workType = bio ? bio?.workType : undefined
  const caseType = bio ? bio?.caseType : undefined
  const seniority = bio ? bio?.seniority : undefined

  return (
    <div
      className={classes.card}
      style={{
        position: 'relative',
        height: 160,
        padding: match768 ? 16 : 24,
      }}
      onClick={() => window.open(`/profile/${data.personal_id}`, '_blank')}
    >
      <div
        style={{
          position: 'absolute',
          top: match768 ? 20 : 28,
          right: match768 ? 16 : 24,
        }}
      >
        <Tooltip
          title="已通過 SWAP 實名認證！"
          arrow
          placement="top"
          marginBottom={-12}
        >
          {icon_verified_small}
        </Tooltip>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
          <Avatar
            data={data.picture ? {
              id: data.id,
              tooltipText: data.nick_name,
              avatarUrl: data.picture
            } :undefined}
            size={68}
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              marginLeft: match768 ? 8 : 4,
            }}
          >
            <Typography
              variant={match768 ? 'h4' : 'h6'}
              style={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                wordBreak: 'break-all',
                marginRight: match768 ? 48 : 44,
              }}
            >
              {data.nick_name}
            </Typography>
            <SWAPSpace size={8} />
            {data.bio ? (
              <Chip
                workType={workType}
                caseType={caseType}
                seniority={seniority}
              />
            ) : (
              <Typography variant="caption2" color="black600">尚無接案資料</Typography>
            )}
          </div>
        </div>
      <SWAPSpace size={match768 ? 24 : 16} />
      <Typography
        variant="body2"
        color="black600"
        style={{
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {data.description ? data.description : '尚無介紹'}
      </Typography>
    </div>
  )
}

const icon_verified_small = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_636_21549)">
      <path
        d="M19.8228 3.99527L19.9893 3.8225L19.8228 3.99527C19.9429 4.11113 20.0949 4.18856 20.2593 4.21767L21.724 4.47717C21.8329 4.49647 21.9269 4.56476 21.9789 4.66238L22.6783 5.97525L22.8902 5.86241L22.6783 5.97525C22.7568 6.12257 22.8774 6.24317 23.0247 6.32165L24.3376 7.02108C24.4352 7.07309 24.5035 7.16709 24.5228 7.27601L24.7823 8.74075C24.8114 8.90511 24.8889 9.05707 25.0047 9.17724L26.0372 10.2481C26.114 10.3278 26.1499 10.4383 26.1346 10.5478L25.9287 12.0211C25.9056 12.1864 25.9323 12.3548 26.0054 12.5049L26.6564 13.8424C26.7048 13.9419 26.7048 14.0581 26.6564 14.1575L26.0054 15.4951C25.9323 15.6452 25.9056 15.8136 25.9287 15.9789L26.1346 17.4522C26.1499 17.5617 26.114 17.6722 26.0372 17.7519L25.0047 18.8228C24.8889 18.9429 24.8114 19.0949 24.7823 19.2592L24.5228 20.724C24.5035 20.8329 24.4352 20.9269 24.3376 20.9789L23.0247 21.6783C22.8774 21.7568 22.7568 21.8774 22.6783 22.0247L21.9789 23.3376C21.9269 23.4352 21.8329 23.5035 21.724 23.5228L20.2593 23.7823C20.0949 23.8114 19.9429 23.8889 19.8228 24.0047L18.7519 25.0372C18.6722 25.114 18.5617 25.1499 18.4522 25.1346L16.9789 24.9287C16.8136 24.9056 16.6452 24.9323 16.4951 25.0054L15.1576 25.6564C15.0581 25.7048 14.9419 25.7048 14.8425 25.6564L13.5049 25.0054C13.3548 24.9323 13.1864 24.9056 13.0211 24.9287L11.5478 25.1346C11.4383 25.1499 11.3278 25.114 11.2481 25.0372L10.1772 24.0047C10.0571 23.8889 9.90511 23.8114 9.74075 23.7823L8.276 23.5228C8.16709 23.5035 8.07309 23.4352 8.02108 23.3376L7.32165 22.0247C7.24317 21.8774 7.12257 21.7568 6.97525 21.6783L6.86241 21.8902L6.97525 21.6783L5.66238 20.9789C5.56476 20.9269 5.49647 20.8329 5.47717 20.724L5.21767 19.2593C5.18856 19.0949 5.11113 18.9429 4.99527 18.8228L4.8225 18.9893L4.99527 18.8228L3.9628 17.7519C3.88602 17.6722 3.85012 17.5617 3.86542 17.4522L4.07126 15.9789C4.09435 15.8136 4.06767 15.6452 3.99462 15.4951L3.3436 14.1576C3.2952 14.0581 3.2952 13.9419 3.3436 13.8424L3.12821 13.7376L3.3436 13.8424L3.99462 12.5049C4.06768 12.3548 4.09435 12.1864 4.07126 12.0211L3.86542 10.5478C3.85012 10.4383 3.88602 10.3278 3.9628 10.2481L4.99527 9.17724C5.11113 9.05707 5.18856 8.90511 5.21767 8.74075L5.47717 7.276C5.49647 7.16709 5.56476 7.07309 5.66238 7.02108L6.97525 6.32165C7.12257 6.24317 7.24317 6.12257 7.32165 5.97525L8.02108 4.66238C8.07309 4.56476 8.16709 4.49647 8.276 4.47717L9.74075 4.21767C9.90511 4.18856 10.0571 4.11113 10.1772 3.99527L11.2481 2.9628C11.3278 2.88602 11.4383 2.85012 11.5478 2.86542L13.0211 3.07126C13.1864 3.09435 13.3548 3.06767 13.5049 2.99462L14.8424 2.3436C14.9419 2.2952 15.0581 2.2952 15.1576 2.3436L15.2624 2.12821L15.1576 2.3436L16.4951 2.99462C16.6452 3.06768 16.8136 3.09435 16.9789 3.07126L18.4522 2.86542C18.5617 2.85012 18.6722 2.88602 18.7519 2.9628L19.8228 3.99527Z"
        fill="#3555D5"
        stroke="#F7B52C"
        strokeWidth="0.48"
      />
      <circle
        cx="14.9999"
        cy="14.0004"
        r="9.36"
        stroke="#C1C7ED"
        strokeWidth="0.48"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0241 11.1757C20.2585 11.4101 20.2585 11.7899 20.0241 12.0243L14.5241 17.5243C14.2898 17.7586 13.9099 17.7586 13.6756 17.5243L11.1756 15.0243C10.9413 14.7899 10.9413 14.4101 11.1756 14.1757C11.4099 13.9414 11.7898 13.9414 12.0241 14.1757L14.0999 16.2515L19.1756 11.1757C19.4099 10.9414 19.7898 10.9414 20.0241 11.1757Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_636_21549"
        x="0.6"
        y="0.8"
        width="28.8"
        height="28.8"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.2" />
        <feGaussianBlur stdDeviation="1.2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_636_21549"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_636_21549"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export default ResumeCardComponent
